export default "__VITE_ASSET__BGLYFfFz__"